import styled from 'styled-components';
import { createGradientOrSolid } from '../../Helper/utils/utils';
import { EBadgePosition, EGradientDirection } from '../../Helper/enums';

interface StyledRibbonBadgeProps {
    bgColor: {
        colorOne: string;
        colorTwo?: string;
        gradientDirection?: EGradientDirection;
    };
    textColor: {
        colorOne: string;
        colorTwo?: string;
        gradientDirection?: EGradientDirection;
    };
    position: EBadgePosition;
}

export const StyledRibbonBadge = styled.div<StyledRibbonBadgeProps>`
    .ac-ribbon-badge {
        font-family: var(--font-family), Arial;
        position: relative;
        z-index: 1000;

        &--center {
            bottom: 12px;

            .ac-ribbon-badge__front {
                background: ${({ bgColor }) => createGradientOrSolid(bgColor)};
                height: 16px;
                width: calc(100% + 8px);
                position: absolute;
                left: -4px;
                z-index: 2;
                text-shadow: 0px 1px 2px black;
                -webkit-box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.55);

                &__text {
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: ${(props: any) => props.textColor};
                    text-align: center;
                    font-size: 10px;
                    text-wrap: nowrap;
                    overflow: hidden;
                }
            }

            @media (min-width: 800px) {
                bottom: 16px;

                .ac-ribbon-badge__front {
                    height: 24px;

                    &__text {
                        font-size: 12px;
                    }
                }
            }
        }

        &--corner {
            height: 65px;
            width: 65px;
            position: absolute;
            top: 0;
            left: 0;
            bottom: unset;
            background: transparent;
            background-size: cover;
            z-index: 1;
            clip-path: polygon(0 0, 100% 0, 100% 100%, 0% 100%);

            .ribbon-corner-text {
                text-shadow: rgb(30 2 30) 0px 1px 2px;
                background: ${({ bgColor }) => createGradientOrSolid(bgColor)};
                -webkit-text-fill-color: ${({ textColor }) =>
                    createGradientOrSolid(textColor)};
                margin: 0;
                font-size: 13px;
                font-weight: 600;
                color: ${(props: any) => props.textColor};
                transform: rotateZ(-45deg) translate(-28px, -15px);
                filter: drop-shadow(0px 1px 1px rgba(0, 0, 0, 0.4));
                height: 26px;
                width: 107px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-family: 'Aller', 'Roboto';
            }
        }
    }

    .ribbon-edge {
        position: absolute;
        z-index: 1;
        border-style: solid;
        height: 0px;
        width: 0px;
        top: 16px;

        @media (min-width: 800px) {
            top: 24px;
        }
    }

    .ribbon-edge-left {
        border-width: 0 4px 4px 0;
        border-color: transparent ${(props: any) => props.bgColor.colorOne}
            transparent transparent;
        left: -4px;
    }

    .ribbon-edge-right {
        right: -4px;
        border-color: transparent transparent transparent
            ${(props: any) => props.bgColor.colorOne};
        border-width: 0 0 4px 4px;
    }
` as any;
